export enum Source {
  Api = 'api',
  Web = 'web',
  WebMobile = 'web-mobile',
  App = 'app',
}
